import React from "react";

function PhotoGrid({ photos, selectedPhotos, onToggleSelect, onPhotoClick, quantities, croppedImages }) {
  const getFilterStyle = (filter) => {
    switch (filter) {
      case "blackwhite":
        return "grayscale(100%)";
      case "sepia":
        return "sepia(100%)";
      default:
        return "none";
    }
  };

  return (
    <div className="photo-grid">
      {photos.map((photo) => {
        const isSelected = selectedPhotos.includes(photo.name);

        // ✅ get this photo's applied sizes
        const photoQuantities = quantities[photo.name] || {};
        const appliedSizes = Object.entries(photoQuantities).filter(([_, qty]) => qty > 0);

        return (
          <div
            key={photo.url}
            className={`photo-item ${isSelected ? "selected" : ""}`}
          >
            <input
              type="checkbox"
              className="photo-checkbox"
              checked={isSelected}
              onChange={() => onToggleSelect(photo.name)}
            />
            <div className="photo-wrapper" onClick={() => onPhotoClick(photo)}>
              <img
                // src={photo.url}
                src={croppedImages[photo.name] || photo.url} 
                alt={photo.name}
                className="photo-preview"
                style={{ filter: getFilterStyle(photo.filterApplied) }}
              />
              {/* ✅ Applied sizes shown at bottom overlay */}
              {appliedSizes.length > 0 && (
                <div className="applied-sizes-overlay">
                  {appliedSizes.map(([label, qty]) => (
                    <span key={label} className="applied-size-pill">
                      {label} <strong style={{ marginLeft: "50px" }}> {qty}</strong>
                    </span>
                  ))}
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default PhotoGrid;